var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.808,
    cy: 12,
    r: 10.5,
    fill: "#1B264F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.718 15.211l.467-2.963h-2.918v-1.923c0-.81.407-1.602 1.714-1.602h1.327V6.2S16.104 6 14.953 6C12.55 6 10.98 7.42 10.98 9.989v2.259H8.31v2.963h2.67v7.165a10.853 10.853 0 003.288 0V15.21h2.451z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "media/contactForm/facebookIcon-c184830f.svg";
export { SvgFacebookIcon as ReactComponent };